//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AnimatedLink from '../common/AnimatedLink.vue'

export default {
  components: {
    AnimatedLink
  },
  props: {
    imgList: {
      type: Array,
      default: null
    },
    mainImg: {
      type: String,
      default: null
    },
    title: {
      type: String,
      default: null
    },
    bottomText: {
      type: String,
      default: null
    },
    link: {
      type: String,
      default: null
    },
    showList: {
      type: Boolean,
      default: false
    },
    itemList: {
      type: Array,
      default: null
    },
    imgSize: {
      type: String,
      default: 'sm'
    }
  }
}
